import { render, staticRenderFns } from "./BoletimMedicaoDetalhes.vue?vue&type=template&id=0f1a7e7c&"
import script from "./BoletimMedicaoDetalhes.vue?vue&type=script&lang=js&"
export * from "./BoletimMedicaoDetalhes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports